module.exports = __webpack_public_path__ + "img/accessory_item_11.4c40e6ca.svg";